import {
  GET_TRANSLATIONS_REQUEST,
  GET_TRANSLATIONS_SUCCESS,
  GET_TRANSLATIONS_FAILURE
 } from '../constants'
import Api from '../services/api.js'

export function getTranslationsRequest(){
  return {
    type: GET_TRANSLATIONS_REQUEST
  }
}

export function getTranslationsSuccess(data){
  return {
    type: GET_TRANSLATIONS_SUCCESS,
    data: data,
  }
}

export function getTranslationsFailure(exception){
  return {
    type: GET_TRANSLATIONS_FAILURE,
    exception: exception
  }
}

export function getTranslations(name) {
  let params = {
    params: {
      name: name
    }
  }
  return dispatch => {
    dispatch(getTranslationsRequest())
    const api = new Api();
    return api.get("/__api/v1/language/translations", params)
    .then(response => {
      dispatch(getTranslationsSuccess(response.data))
    })
    .catch(error => dispatch(getTranslationsFailure(error)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/language.js